/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Embedding_Priority_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not update the embedding priority." |
*
* @param {Spaces_Embedding_Priority_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_embedding_priority_error = /** @type {((inputs?: Spaces_Embedding_Priority_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Embedding_Priority_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettungspriorität konnte nicht aktualisiert werden.")
	return /** @type {LocalizedString} */ ("Could not update the embedding priority.")
});